/**
 * Toggle persistence per slice here (ONE place).
 * true  => slice is persisted in sessionStorage
 * false => slice is NOT persisted
 */
export const PERSIST = {
  auth: true,
  // add more when you create them:
  // listings: false,
  // enquiries: false,
};
